module.exports = __webpack_public_path__ + "static/media/website-06.36455d20.png";